import {INVALID_TOKEN} from './index';

export function invalidateToken() {
  return {
    type: INVALID_TOKEN,
  };
}
